import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppToolbar } from '../../components/app-toolbar/app-toolbar';

@Component({
  selector: 'app-public-component',
  imports: [RouterModule, AppToolbar],
  templateUrl: './public-component.html',
  styleUrl: './public-component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicComponent {}
